@if (showLoadingIndicator) {
  <div class="loading">
    <div>
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </div>
}
